type NarrativeContent = {
  text?: {
    entityMap?: Record<string, unknown>;
  };
  entityMap?: Record<string, unknown>;
};

export const resolveNarrativeEntityMap = (content?: NarrativeContent) => {
  if (!content) return {};
  return content.text?.entityMap ?? content.entityMap ?? {};
};

type DraftEntity = {
  type?: string;
  data?: {
    url?: string;
    value?: string;
  };
};

export const narrativeEntityToHtml = (entity?: DraftEntity, text?: string) => {
  if (!entity?.type || !text) return undefined;

  if (entity.type.toUpperCase() === 'MENTION') {
    const url = entity.data?.url ?? '#';
    const value = entity.data?.value ?? '';
    return `<a href="${url}" class="wysiwyg-mention" data-mention data-value="${value}">${text}</a>`;
  }

  return undefined;
};
